import React from "react"
import {Box} from "@mui/material"
import Icons from "../../assets/Icons"

export const iconWidgetPrototype = [
    {
        key: "icon",
        type: "ICONSELECT",
        label: "Icon",
        size: 3,
    },
    {
        key: "iconColor",
        type: "COLOR",
        label: "Icon Farbe",
        size: 3,
    },
]

const IconWidget = ({widget, value}) => {
    const icon = Icons(widget.iconColor)[widget.icon]
    const displayValue = value
        ? <img src={window._env_.ARBEITSKONSOLE_SERVER_URL + value} />
        : icon
    return (
        <Box
            height={"32px"} 
            width={"32px"}
            display="flex"
            alignItems="center"
            p={1}
        >
            {displayValue ? displayValue : <>No Image</>}
        </Box>
    )
}

export default IconWidget
